/* @flow */

//----------------------------------------------------------------------//
// Imported NPM modules
//----------------------------------------------------------------------//

import * as React from 'react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// CSS
//----------------------------------------------------------------------//

import styles from './AccountSummary.module.scss';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

function AccountSummary({ data, t }: Object): React.StatelessFunctionalComponent<*> {
  const labels: Object = {
    contracts: 'general:contract_plural',
    assets: 'general:asset_plural',
    projects: 'general:project_plural',
    locations: 'general:location_plural',
    users: 'general:user_plural',
  };

  if (data && Object.keys(data).length > 0) {
    return (
      <div>
        <table className={styles['account-summary-table']}>
          <tbody>
            {Object.keys(data).map((key: string, index: number) => {
              return (
                <tr key={index.toString()}>
                  <td>
                    <svg>
                      <use xlinkHref={`#icon-${key}`} />
                    </svg>
                  </td>
                  <td>
                    <b>{`${t(labels[key])}:`}</b>
                  </td>
                  <td>{data[key]}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return null;
}

export default translate()(AccountSummary);
